import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DownloadIcon from '@mui/icons-material/Download';

const ActivityRegistrationDialog = ({ 
  open, 
  onClose, 
  loading, 
  qrToken, 
  error,
  activityName 
}) => {
  
  // Generar URL del QR usando API pública
  const getQRUrl = (token) => {
    if (!token) return '';
    // API de QR Server - gratis y sin límites
    const size = 220;
    const encodedToken = encodeURIComponent(token);
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodedToken}`;
  };

  const handleDownloadQR = () => {
    if (qrToken) {
      const link = document.createElement('a');
      link.download = `qr-${activityName || 'actividad'}.png`;
      link.href = getQRUrl(qrToken);
      link.target = '_blank';
      link.click();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: 'linear-gradient(135deg, #1e1b2e 0%, #2a2640 100%)',
          border: '1px solid rgba(139, 92, 246, 0.3)',
          borderRadius: 3
        }
      }}
    >
      <DialogTitle sx={{ 
        color: 'white', 
        textAlign: 'center',
        borderBottom: '1px solid rgba(139, 92, 246, 0.2)',
        pb: 2
      }}>
        {loading ? 'Procesando registro...' : qrToken ? '¡Registro Exitoso!' : 'Error en el Registro'}
      </DialogTitle>

      <DialogContent sx={{ py: 4 }}>
        {loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <CircularProgress sx={{ color: '#8b5cf6' }} />
            <Typography sx={{ color: '#888' }}>
              Procesando tu registro...
            </Typography>
          </Box>
        ) : error ? (
          <Alert 
            severity="error" 
            sx={{ 
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              color: '#fca5a5',
              '& .MuiAlert-icon': {
                color: '#ef4444'
              }
            }}
          >
            {error}
          </Alert>
        ) : qrToken ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckCircleOutlineIcon sx={{ color: '#10b981', fontSize: 32 }} />
              <Typography variant="h6" sx={{ color: '#10b981', fontWeight: 600 }}>
                Registro Confirmado
              </Typography>
            </Box>

            {activityName && (
              <Typography sx={{ 
                color: 'white', 
                textAlign: 'center', 
                fontSize: '1.1rem',
                fontWeight: 500 
              }}>
                {activityName}
              </Typography>
            )}

            <Box 
              sx={{
                background: 'white',
                p: 3,
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(139, 92, 246, 0.3)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img 
                src={getQRUrl(qrToken)}
                alt="Código QR de registro"
                style={{
                  width: '220px',
                  height: '220px',
                  display: 'block'
                }}
              />
            </Box>

            <Typography sx={{ 
              color: '#a78bfa', 
              textAlign: 'center', 
              fontSize: '0.9rem',
              maxWidth: '85%',
              lineHeight: 1.6
            }}>
              Presenta este código QR al momento de ingresar a la actividad
            </Typography>

            <Button
              onClick={handleDownloadQR}
              variant="outlined"
              size="small"
              startIcon={<DownloadIcon />}
              sx={{
                textTransform: 'none',
                borderColor: 'rgba(139, 92, 246, 0.5)',
                color: '#a78bfa',
                '&:hover': { 
                  borderColor: '#8b5cf6',
                  backgroundColor: 'rgba(139, 92, 246, 0.1)'
                }
              }}
            >
              Descargar QR
            </Button>
          </Box>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ 
        justifyContent: 'center', 
        pb: 3,
        borderTop: '1px solid rgba(139, 92, 246, 0.2)',
        pt: 2
      }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            px: 4,
            backgroundColor: '#8b5cf6',
            '&:hover': { backgroundColor: '#7c3aed' }
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityRegistrationDialog;